import { render, staticRenderFns } from "./TPAsTable.vue?vue&type=template&id=0a4992b4&"
import script from "./TPAsTable.vue?vue&type=script&lang=js&"
export * from "./TPAsTable.vue?vue&type=script&lang=js&"
import style0 from "./TPAsTable.vue?vue&type=style&index=0&id=0a4992b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports